@if (transportTypeList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onTransportTypeChange($event)"
    [options]="transportTypeList"
    [(ngModel)]="transportType"
    filterBy="label, value"
    [disabled]="disabled()"
    [showClear]="showClear()"
    [placeholder]="placeholder"
  >
    <ng-template #selectedItem>
      @if (transportType) {
        <p-chip
          [label]="getTransportTypeLabel(transportType)"
          [removable]="!disabled()"
          removeIcon="pi pi-times"
          (onRemove)="clearTransportType()"
        />
      }
    </ng-template>
  </p-select>
}
